// Suppliers Getters

export const getSuppliersList = state => {
  return state.suppliersList
}

export const getSupplierInfo = state => {
  return state.supplierInfo
}

export const getSupplierTypeList = state => {
  return state.supplierTypeList
}

export const getFullVendersList = state => {
  return state.fullVendersList
}
